<template>
  <div id="app">
    <!-- <div  class="menu-box"> -->

      <novoMenu :showMenu="showMenu"  ref="menu"></novoMenu>
        <!-- <div :class="['container', loginStyle ? 'login-class' : '', showMenu ? '' :'not-menu' ,showSideBar? '' :'not-show-sidebar' ]"> -->
          <router-view/>
        <!-- </div> -->
      
    <!-- </div> -->


  </div>
</template>

<script>
import novoMenu from "./components/novo-menu";
import {notMenuArr,notSideBarArr} from 'common/js/notMenuArr';
export default {
  name: "App",
  data() {
    return {
      notMenuArr,
      notSideBarArr,
      showMenu: true,
      loginStyle: false,
      showSideBar :true,
    };
  },
  components: {
    novoMenu
  },
  methods: {
    toggleMenu() {
      this.$refs.menu.getAvtiveMenuName();
    }
  },
  created: function() {
    // this.toggleMenu();
  },

  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.toggleMenu();
    }
  }
};
</script>

<style lang="scss">
html,
body {
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  width: 100%;
  // overflow: hidden;
}
#app {
  // height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .login-class {
    width: 100%;
    height: 100%;
    background: url("~common/image/login/back.png") no-repeat;
    background-size: cover;
    overflow: auto;
  }
  .container {
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
  .open-token{
    .ivu-modal-header{
      border-bottom:none;
    }
    .ivu-modal-footer{
      border-top:none;
    }
  }
  .noFooter {
    .ivu-modal-footer {
      padding: 0;
      border: none;
    }
  }
.metting-timeline .reservation-introduction .ivu-poptip-rel {
  width: 100%;
  height: 100%;
}

#app .menu-box {
  position: fixed;
  width: 100%;
  height: 100%;
}

  .width1060 {
    margin: 0 auto;
    width: 1060px;
  }

.goUp {
  -moz-animation: upAnimation 1s ease-in-out;	/* Firefox */
  -webkit-animation: upAnimation 1s ease-in-out;	/* Safari 和 Chrome */
  -o-animation: upAnimation 1s ease-in-out;	/* Opera */
  animation: upAnimation 1s ease-in-out;
  -moz-animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.upAndLarge {
  -moz-animation: upAndLarge 2s ease-in-out;	/* Firefox */
  -webkit-animation: upAndLarge 2s ease-in-out;	/* Safari 和 Chrome */
  -o-animation: upAndLarge 2s ease-in-out;	/* Opera */
  animation: upAndLarge 2s ease-in-out;
  -moz-animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
@keyframes upAnimation {
  0% {
    -webkit-transform: translateY(50px);
    transform: translateY(50px);
    // visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    // visibility: visible;
  }
}
@keyframes upAndLarge {
   0% {
     -webkit-transform: translateY(100px) scale(0.7);
     transform:translateY(100px) scale(0.7);
   }
   100% {
     -webkit-transform: translateY(0) scale(1);
     transform: translateY(0) scale(1);
   }
 }


</style>



// WEBPACK FOOTER //
// src/App.vue